import React, { useState } from 'react'
import { Icon } from '@blueprintjs/core'
import { useLocalStorage, useOnlineUtils } from '../../Hooks/offline'
import { ApolloConsumer, gql } from '@apollo/client'
import { NavButton } from '../../Elements'
import { useToast } from '../../Hooks/toast'

// import {
//     BOULDER_WORK_ORDER_FRAGMENT,
//     CUSTOMER_FRAGMENT,
//     DOCUMENT_FRAGMENT,
//     ESTIMATE_FRAGMENT,
//     GUNITE_WORK_ORDER_FRAGMENT,
//     HOMEOWNER_FRAGMENT,
//     JOB_FRAGMENT,
//     JOB_SEARCH_FRAGMENT,
//     PEBBLE_DAILY_WORK_ORDER_FRAGMENT,
//     PEBBLE_WORK_ORDER_FRAGMENT,
//     WARRANTY_WORK_ORDER_FRAGMENT
// } from '../../utils/queries'

// move to queries
const VERSION = gql`
{
  apiVersion {
    id
    version
  }
}
`

// const OFFLINE_JOBS = gql`
//     ${JOB_FRAGMENT}
//     ${JOB_SEARCH_FRAGMENT}
//     ${ESTIMATE_FRAGMENT}
//     ${GUNITE_WORK_ORDER_FRAGMENT}
//     ${PEBBLE_WORK_ORDER_FRAGMENT}
//     ${PEBBLE_DAILY_WORK_ORDER_FRAGMENT}
//     ${BOULDER_WORK_ORDER_FRAGMENT}
//     ${WARRANTY_WORK_ORDER_FRAGMENT}
//     ${DOCUMENT_FRAGMENT}
//     ${HOMEOWNER_FRAGMENT}
//     ${CUSTOMER_FRAGMENT}
//     query OfflineJobs
//     {
//         offline_jobs {
//             ...JobFragment
//         }

//         offline_job_search {
//             ...JobSearchFragment
//         }

//         offline_estimates {
//             ...EstimateFragment
//         }

//         offline_estimate_search {
//             ...EstimateFragment
//         }

//         offlineGuniteWorkOrders {
//             ...GuniteWorkOrderOfflineFragment
//         }

//         offlinePebbleWorkOrders {
//             ...PebbleWorkOrderOfflineFragment
//         }

//         offlinePebbleDailyWorkOrders {
//             ...PebbleDailyWorkOrderOfflineFragment
//         }

//         offlineBoulderWorkOrders {
//             ...BoulderWorkOrderOfflineFragment
//         }

//         offlineWarrantyWorkOrders {
//             ...WarrantyWorkOrderOfflineFragment
//         }

//         offlineDocuments {
//             ...DocumentOfflineFragment
//         }
//         offline_homeowners {
//             ...HomeownerFragment
//         }

//         offline_customers {
//             ...CustomerFragment
//         }

//         customers: lookupCustomer {
//             id
//             company_name
//             is_active
//         }
//         customer_contacts {
//             id
//             first_name
//             last_name
//             phone_number
//             customer_id
//         }
//         homeowners {
//             id
//             first_name
//             last_name
//             mailing_address
//             city
//             state
//             zip_code
//         }
//         lookupJobType {
//             id
//             name
//             show_gunite
//             show_pebble
//             show_warranty
//         }
//         lookupJobCategory {
//             id
//             name
//         }
//         lookupPoolType {
//             id
//             name
//         }
//         lookupSpaType {
//             id
//             name
//         }
//         lookupJobStatus {
//             id
//             name
//             show_gunite
//             show_pebble
//             show_warranty
//         }
//         lookupPebbleColor {
//             id
//             name
//             material_type {
//                 id
//                 name
//             }
//             pool_code
//             spa_code
//             price_level
//             condition
//             batch_ratio
//         }
//         lookupPebbleColorAdditive {
//             id
//             name
//             quantity_per_batch
//             quantity_per_job
//             additive_product_id
//         }
//         lookupPebbleColorMaterialType {
//             id
//             name
//         }  
//         lookupPoolSection {
//             id
//             name
//             additional_batches
//             is_add_pool_batches
//         }
//         lookupCrewTypes {
//             id
//             name
//             lookup_company_division_id
//             subdivision
//         }
//         lookupGuniteHistoryTypes {
//             id
//             name
//         }
//         lookupJobOrder {
//             id
//             name
//         }
//         lookupAddition {
//             id
//             name
//             type
//         }
//         lookupEmployee {
//             id
//             name
//             crew_types {
//                 id
//             }
//         }
//         lookupRepairSupervisor {
//             id
//             name
//             crew_types {
//                 id
//             }
//         }
//         jobDescriptionJobType{
//             job_type {
//                 id
//                 name
//             }
//             job_description {
//                 id
//                 name
//             }
//         }
//         lookupJobPriority {
//             id
//             name
//         }
//         lookupWarrantyCategory {
//             id
//             name
//         }
//         lookupSlurryType {
//             id
//             name
//             type
//         }
//         lookupVgbMainDrainsBy{
//             id
//             name
//         }
//         lookupCity {
//             id
//             name
//         }
//         lookupPositionTypes {
//             id
//             name
//         }
//         lookupDocumentTag {
//             id
//             name
//             is_active
//         }
// }`



export const OfflineDownloader = () => (
    <ApolloConsumer>
        {(client) => <OfflineDownloaderCore client={client} />}
    </ApolloConsumer>
)

// function urlContentToDataUri(url){
//     return  fetch(url)
//             .then( response => response.blob() )
//             .then( blob => new Promise( callback =>{
//                 let reader = new FileReader() ;
//                 reader.onload = function(){ callback(this.result) } ;
//                 reader.readAsDataURL(blob) ;
//             }) ) ;
// }

const OfflineDownloaderCore = ({ client }) => {
    // eslint-disable-next-line
    const [isDownloading, setIsDownloading] = useState(false)
    const { isOnline, setIsOnline, setGoOnlineDialog, rawSetNetworkError } = useOnlineUtils()
    // eslint-disable-next-line
    const { setLocalStorage, localState } = useLocalStorage()
    const { showError } = useToast()

    // const mergeExistingJobsWithResponse = (data) => {
    //     const nonExpiredViewedCachedJobs = localState?.job?.filter(x => x?.expiresAt > moment().unix() * 1000)
    //     if (nonExpiredViewedCachedJobs) {
    //         data.job = data.job.concat(nonExpiredViewedCachedJobs)
    //     }

    //     setLocalStorage(data)
    // }

    // #region DEV NOTE:  Turned this off for now since it is broken anyway
    // const { networkStatus } = useQuery(OFFLINE_JOBS, {
    //     fetchPolicy: 'network-only',
    //     notifyOnNetworkStatusChange: true,
    //     onCompleted: async (data) => {
    //         const offline_data = buildOfflineStructure(data)
    //         await Promise.all(offline_data.documents.map(async d => {
    //             d.document_url = await urlContentToDataUri(d.document_url)
    //         }))

    //         setLocalStorage(offline_data)
    //     },
    //     onError: (error) => {
    //         console.log("error: ", error)
    //     },
    //     pollInterval: 3600000 // 1 hour
    // })

    // if (networkStatus === NetworkStatus.poll && !isDownloading) {
    //     setIsDownloading(true)
    // }

    // if (networkStatus === NetworkStatus.ready && isDownloading) {
    //     setIsDownloading(false)
    // }
    // #endregion DEV NOTE:  Turned this off for now since it is broken anyway

    const tryGoOnline = async () => {
        let keys = Object.keys(localState)
        let filteredKeys = keys.filter(k => k.indexOf(':') !== -1)
        let docsToUpload = localState['documents'].filter(document => !document.id)
        try {
            let version = await client.query({
                query: VERSION,
                variables: {},
                fetchPolicy: "network-only"
            })
            if (!version) {
                showError(`No network connection detected. Please try again when connectivity has returned.`)
            }

            if (filteredKeys.length === 0 && docsToUpload.length === 0) {
                if (version) {
                    rawSetNetworkError(false)
                    setIsOnline(true)
                }
            } else {
                if (version) {
                    setGoOnlineDialog(true)
                }
            }
        } catch (error) {
            showError(`No network connection detected. Please try again when connectivity has returned.`)
        }
    }

    return <>
        {isDownloading && <Icon icon='refresh' className='spinner' />}
        {!isOnline && <NavButton icon='globe-network' onClick={tryGoOnline}> Go Online</NavButton>}
    </>

}

// const buildOfflineStructure = (data) => {
//     return {
//         job: data.offline_jobs,
//         jobs: data.offline_job_search,
//         estimate: data.offline_estimates,
//         estimates: data.offline_estimate_search,
//         guniteWorkOrders: data.offlineGuniteWorkOrders,
//         pebbleWorkOrders: data.offlinePebbleWorkOrders,
//         pebbleDailyWorkOrders: data.offlinePebbleDailyWorkOrders,
//         boulderWorkOrders: data.offlineBoulderWorkOrders,
//         warrantyWorkOrders: data.offlineWarrantyWorkOrders,
//         documents: data.offlineDocuments,
//         customer_contacts: data.customer_contacts,
//         customers: data.customers,
//         customer: data.offline_customers,
//         homeowners: data.homeowners,
//         homeowner: data.offline_homeowners,
//         jobDescriptionJobType: data.jobDescriptionJobType,
//         lookupAddition: data.lookupAddition,
//         lookupCrewTypes: data.lookupCrewTypes,
//         lookupCity: data.lookupCity,
//         lookupEmployee: data.lookupEmployee,
//         lookupJobOrder: data.lookupJobOrder,
//         lookupGuniteHistoryTypes: data.lookupGuniteHistoryTypes,
//         lookupJobCategory: data.lookupJobCategory,
//         lookupJobPriority: data.lookupJobPriority,
//         lookupJobStatus: data.lookupJobStatus,
//         lookupJobType: data.lookupJobType,
//         lookupPebbleColor: data.lookupPebbleColor,
//         lookupPebbleColorAdditive: data.lookupPebbleColorAdditive,
//         lookupPebbleColorMaterialType: data.lookupPebbleColorMaterialType,
//         lookupPoolSection: data.lookupPoolSection,
//         lookupRepairSupervisor: data.lookupRepairSupervisor,
//         lookupSlurryType: data.lookupSlurryType,
//         lookupSpaType: data.lookupSpaType,
//         lookupVgbMainDrainsBy: data.lookupVgbMainDrainsBy,
//         lookupWarrantyCategory: data.lookupWarrantyCategory,
//         lookupPositionTypes: data.lookupPositionTypes
//     }
// }